/**
 * /forensic-enhancer — export: the one menu the result leaves through.
 *
 *   PNG / JPG / copy      — the frame, at cost of one daily unit per FILE
 *   ZIP / PDF report / MP4 clip — Premium capabilities (browser-side, they cost
 *                           us nothing; they are sold as capability, not as a
 *                           worse free lane — see video-compressor's batch)
 *
 * The cap unit is the source file: S.limitKey is stamped once in openFile, so
 * five exports of one recording are one unit and the promise on the wall
 * ("re-running the same file today is free") holds.
 */
(function () {
'use strict';
if (!window.FX || window.FXExport) return;
var FX = window.FX, S = FX.S, T = FX.T, CFG = FX.CFG;
var $ = function (id) { return document.getElementById(id); };
var App = function () { return window.FXApp; };
var toast = function (m, k) { try { window.__toast(m, k || 'info'); } catch (_) {} };
// the same channel as app.js (feature_use + action); the old 'tool-used' event had no listener
var stageEvt = function (name, data) { try { window.__ae && window.__ae('feature_use', Object.assign({ slug: CFG.slug, action: name }, data || {})); } catch (_) {} };

var btn = $('fxDownloadBtn'), menu = $('fxDownloadMenu');
function isPro() { try { return !!(window.__toolLimit && window.__toolLimit.isPro()); } catch (_) { return false; } }
function openMenu(open) {
    menu.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
        var pro = isPro();
        menu.querySelectorAll('[data-pro-badge]').forEach(function (b) { b.hidden = pro; });
        menu.querySelectorAll('[data-video-only]').forEach(function (r) { r.hidden = S.kind !== 'video'; });
        $('fxClipRow').hidden = true;
        if (S.kind === 'video') {
            var t = S.sourceMeta.time || 0;
            $('fxClipFrom').value = App().fmtTime(Math.max(0, t - 2));
            $('fxClipTo').value = App().fmtTime(Math.min(S.video.duration, t + 3));
        }
    }
}
btn.addEventListener('click', function () { openMenu(menu.hidden); });
document.addEventListener('click', function (e) { if (!menu.hidden && !menu.contains(e.target) && e.target !== btn && !btn.contains(e.target)) openMenu(false); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) openMenu(false); });
$('fxJpgQ').addEventListener('input', function () { $('fxJpgQVal').textContent = this.value; });
menu.querySelectorAll('[data-export]').forEach(function (row) {
    row.addEventListener('click', function () {
        var kind = row.dataset.export;
        if (row.dataset.premium && !isPro()) {
            toast(T.dl_need_premium.replace(':plan', CFG.planName), 'warning');
            if (CFG.proUrl) window.open(CFG.proUrl, '_blank', 'noopener');
            stageEvt('premium_gate', { kind: kind });
            return;
        }
        if (kind === 'clip') { $('fxClipRow').hidden = false; return; }
        openMenu(false);
        run(kind);
    });
});
$('fxClipGo').addEventListener('click', function () { openMenu(false); run('clip'); });

/* Daily cap: one unit per source file, spent only when a result is delivered —
   the engine owns the rule (FX.bill), so an export and an on-screen fusion of
   the same file are the same unit. */
function beginRun() { return FX.bill(); }
function exportCanvas(withMarks) {
    var img = FX.composite(); if (!img) return null;
    var c = FX.imageDataToCanvas(img);
    var ui = App().UI;
    if (withMarks && ui.anno.visible && ui.anno.items.length) {
        var anno = $('fxAnnoCanvas');
        if (anno.width === c.width && anno.height === c.height) c.getContext('2d').drawImage(anno, 0, 0);
    }
    if (S.aiResult) {
        // Reconstructed pixels leave the page labelled as such — in the corner
        // of the picture itself, where a screenshot cannot lose it.
        var x = c.getContext('2d'); var fs = Math.max(11, Math.round(c.width / 60));
        x.font = 'bold ' + fs + 'px system-ui, sans-serif'; var label = T.ai_tag; var w = x.measureText(label).width + fs;
        x.fillStyle = 'rgba(88,60,160,.85)'; x.fillRect(c.width - w - fs / 2, fs / 2, w, fs * 1.6);
        x.fillStyle = '#fff'; x.textBaseline = 'middle'; x.fillText(label, c.width - w, fs / 2 + fs * 0.8);
    }
    return c;
}
function outName(ext, suffix) {
    var base = (S.file && S.file.name || 'frame').replace(/\.[^.]+$/, '');
    var stamp = S.kind === 'video' ? '_' + App().fmtTime(S.sourceMeta.time, true).replace(/[:.]/g, '-') + '_f' + S.sourceMeta.frame : '';
    var name = base + stamp + (suffix || '');
    if (window.__outputName && window.__outputName.join) return window.__outputName.join(name, ext) || (name + '.' + ext);
    return name + '.' + ext;
}
function deliver(blob, name) {
    if (window.__downloadFile) return Promise.resolve(window.__downloadFile(blob, name));
    var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 5000);
    return Promise.resolve(true);
}
function complete(kind, extra) {
    try { window.__aeToolComplete && window.__aeToolComplete(Object.assign({ kind: kind, file_type: S.kind, stacked: !!(S.sourceMeta.stacked), tracked: !!S.sourceMeta.tracked, ai: !!S.aiResult, steps: FX.chainFilters(S.enh).length, geom: S.geom.actions.length }, extra || {})); } catch (_) {}
    try { window.__stage && window.__stage('export'); } catch (_) {}
}

function run(kind) {
    if (!S.current) return;
    if (kind === 'png' || kind === 'jpg' || kind === 'copy') return exportFrame(kind);
    if (kind === 'zip') return exportZip();
    if (kind === 'pdf') return exportReport();
    if (kind === 'clip') return exportClip();
}

function exportFrame(kind) {
    var c = exportCanvas($('fxExportAnno').checked); if (!c) return;
    var r = beginRun(); if (!r) return;
    var mime = kind === 'jpg' ? 'image/jpeg' : 'image/png', q = parseInt($('fxJpgQ').value, 10) / 100;
    c.toBlob(function (blob) {
        if (!blob) { r.abort(); toast(T.err_worker, 'error'); return; }
        if (kind === 'copy') {
            if (!(navigator.clipboard && navigator.clipboard.write && typeof ClipboardItem !== 'undefined')) { r.abort(); toast(T.copy_failed, 'error'); return; }
            navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]).then(function () { r.commit(); toast(T.copied, 'success'); complete('copy'); }, function () { r.abort(); toast(T.copy_failed, 'error'); });
            return;
        }
        deliver(blob, outName(kind)).then(function (ok) { if (ok === false) { r.abort(); return; } r.commit(); complete(kind, { bytes: blob.size }); });
    }, mime, q);
}

function exportZip() {
    var sel = S.captured.filter(function (c) { return c.selected; });
    if (!sel.length) sel = S.captured.slice();
    if (!sel.length) { toast(T.dl_zip_none, 'warning'); return; }
    var r = beginRun(); if (!r) return;
    toast(T.dl_preparing, 'info');
    var items = [], i = 0;
    var base = (S.file && S.file.name || 'frames').replace(/\.[^.]+$/, '');
    (function next() {
        if (i >= sel.length) {
            var name = (window.__outputName && window.__outputName.join) ? window.__outputName.join(base + '_frames', 'zip') : base + '_frames.zip';
            var bd = window.__batchDeliver;
            var p = bd && bd.deliver ? bd.deliver(items, { slug: CFG.slug, zipName: name, name: name }) : legacyZip(items, name);
            return p.then(function (res) { if (res && res.via === 'cancelled') { r.abort(); return; } r.commit(); toast(T.dl_done, 'success'); complete('zip', { n: items.length }); }, function () { r.abort(); toast(T.err_worker, 'error'); });
        }
        var c = sel[i++];
        var cv = document.createElement('canvas'); cv.width = c.w; cv.height = c.h; cv.getContext('2d').drawImage(c.bmp, 0, 0);
        cv.toBlob(function (blob) {
            var nm = 'frame_' + String(i).padStart(4, '0') + '_' + App().fmtTime(c.time, true).replace(/[:.]/g, '-') + '.png';
            if (blob) items.push({ name: nm, blob: blob });
            next();
        }, 'image/png');
    })();
}
function legacyZip(items, name) {
    return new Promise(function (res, rej) {
        var s = document.createElement('script'); s.src = CFG.jszip;
        s.onload = function () { var z = new JSZip(); items.forEach(function (it) { z.file(it.name, it.blob); }); z.generateAsync({ type: 'blob' }).then(function (b) { return deliver(b, name); }).then(res, rej); };
        s.onerror = rej; document.head.appendChild(s);
    });
}

/* The report is the thing a driver takes to the insurer: the ORIGINAL frame,
   the enhanced frame, every step with its parameters (so anyone can repeat
   them), the file's hash, and an honest note where pixels were reconstructed. */
function exportReport() {
    var r = beginRun(); if (!r) return;
    var esc = App().esc, fmt = App().fmtTime;
    var out = exportCanvas($('fxExportAnno').checked);
    // after a plate fusion the "original" is the box of the reference frame as
    // the camera recorded it — the fused picture is the result, not the source
    var orig = FX.imageDataToCanvas(S.sourceMeta.refCrop || S.source);
    if (S.sourceMeta.refCrop && S.sourceMeta.tracked) {
        // the box is a few dozen pixels: shown at the result's scale, pixel for pixel
        var k = S.sourceMeta.tracked.K || 3, big = document.createElement('canvas');
        big.width = orig.width * k; big.height = orig.height * k;
        var bx = big.getContext('2d'); bx.imageSmoothingEnabled = false; bx.drawImage(orig, 0, 0, big.width, big.height);
        orig = big;
    }
    var h = '<div style="font-family:Arial,Helvetica,sans-serif;max-width:720px;margin:0 auto;padding:16px;color:#111;font-size:12px;line-height:1.45">';
    h += '<h1 style="font-size:20px;border-bottom:2px solid #222;padding-bottom:6px;margin:0 0 6px">' + esc(T.report_title) + '</h1>';
    h += '<div style="color:#666">' + esc(T.report_generated) + ' ' + new Date().toISOString().replace('T', ' ').slice(0, 19) + ' UTC</div>';
    var rows = [];
    var row = function (k, v) { rows.push('<tr><td style="padding:4px 6px;border:1px solid #ddd;font-weight:bold;white-space:nowrap">' + esc(k) + '</td><td style="padding:4px 6px;border:1px solid #ddd;word-break:break-all">' + v + '</td></tr>'); };
    if (S.file) {
        var of = S.original || S.file;
        row(T.report_file, esc(of.name) + ' · ' + Math.round(of.size / 1024) + ' KB · ' + esc(of.type || '—')
            + (S.rescueTier && S.rescueTier !== 'native' ? ' · ' + esc(T.report_converted.replace(':tier', S.rescueTier)) : ''));
        if (S.kind === 'video') row(T.info_res, S.video.w + '×' + S.video.h + ' · ' + S.video.fps + ' fps · ' + fmt(S.video.duration, true) + (S.video.codec ? ' · ' + esc(S.video.codec) : ''));
        if (S.hashes) row(T.report_hash, '<span style="font-family:monospace;font-size:12px">SHA-256 ' + S.hashes.sha256 + '<br>SHA-1 ' + S.hashes.sha1 + '</span>');
    }
    if (S.kind === 'video') row(T.report_frame_time, fmt(S.sourceMeta.time, true) + ' · #' + S.sourceMeta.frame);
    if (S.sourceMeta.stacked) { var st = S.sourceMeta.stacked; row(T.report_stack, st.n + ' × ' + st.mode + (st.aligned ? ' · ' + T.stack_shift.replace(':px', st.maxShift) : '') + (st.roi ? ' · ROI' : '')); }
    if (S.sourceMeta.tracked) {
        var tk = S.sourceMeta.tracked, b = tk.box || {};
        row(T.report_track, esc(T.report_track_value
            .replace(':used', tk.used).replace(':n', tk.n).replace(':from', fmt(tk.t0, true)).replace(':to', fmt(tk.t1, true))
            .replace(':k', tk.K).replace(':rho', (tk.rho || 0).toFixed(2)))
            + '<br><span style="font-family:monospace;font-size:12px">box ' + Math.round(b.x) + ',' + Math.round(b.y) + ' ' + Math.round(b.w) + '×' + Math.round(b.h)
            + ' · model ' + esc(tk.model || '') + ' (ECC) · scale ' + tk.scaleMin + '–' + tk.scaleMax + ' · fusion: shift-and-add, Gaussian splat, Huber reweighting, ' + tk.w + '×' + tk.h + '</span>');
    }
    var g = S.geom, geom = [];
    if (g.deint !== 'off') geom.push(T.st_deint_report ? T.st_deint_report : 'deinterlace=' + g.deint);
    if (g.k1) geom.push('undistort k1=' + g.k1);
    if (g.rotate) geom.push('rotate ' + (g.rotate * 90) + '°');
    if (g.par !== 1) geom.push('pixel aspect ' + g.par.toFixed(4));
    g.actions.forEach(function (a) { if (a.type === 'crop') geom.push('crop ' + a.rect.x + ',' + a.rect.y + ' ' + a.rect.w + '×' + a.rect.h); else if (a.type === 'persp') geom.push('perspective → ' + a.outW + '×' + a.outH + ' [' + a.quad.map(function (p) { return Math.round(p.x) + ',' + Math.round(p.y); }).join(' ') + ']'); });
    if (geom.length) row(T.report_geometry, esc(geom.join(' → ')));
    var steps = FX.chainFilters(S.enh).map(function (f) { return f.name + '(' + Object.keys(f.params).map(function (k) { var v = f.params[k]; return k + '=' + (typeof v === 'object' ? JSON.stringify(v) : v); }).join(', ') + ')'; });
    if (S.enh.strength < 0.999) steps.push('strength=' + Math.round(S.enh.strength * 100) + '%');
    if (steps.length) row(T.report_steps, esc(steps.join(' → ')));
    if (S.aiResult) row(T.report_ai, esc(T.ai_tag + ' ×' + S.aiResult.scale + ' — ' + T.ai_caution));
    if (S.rulerScale) row(T.report_ruler, esc(S.rulerScale.perPx.toPrecision(3) + ' ' + S.rulerScale.unit + '/px'));
    // the plate reader's list as it stood on the screen: probabilities and the mask, never one «answer»
    if (S.plateRead && S.plateRead.lines && S.plateRead.lines.length) {
        row(T.report_plate, esc(T.plate_copy_head) + '<br><span style="font-family:monospace;font-size:12px">'
            + S.plateRead.lines.map(esc).join('<br>') + (S.plateRead.mask ? '<br>' + esc(T.plate_mask) + ': ' + esc(S.plateRead.mask) : '') + '</span>');
    }
    h += '<table style="width:100%;border-collapse:collapse;margin:10px 0">' + rows.join('') + '</table>';
    h += '<h2 style="font-size:14px;margin:12px 0 4px">' + esc(T.report_original) + '</h2><img src="' + orig.toDataURL('image/jpeg', 0.85) + '" style="max-width:100%;border:1px solid #ddd">';
    h += '<h2 style="font-size:14px;margin:12px 0 4px">' + esc(T.report_enhanced) + '</h2><img src="' + out.toDataURL('image/jpeg', 0.9) + '" style="max-width:100%;border:1px solid #ddd">';
    h += '<div style="margin-top:16px;padding-top:8px;border-top:1px solid #ddd;color:#888;font-size:12px">' + esc(T.report_footer) + '</div></div>';
    var el = document.createElement('div'); el.innerHTML = h;
    if (!window.__generatePDF) { r.abort(); toast(T.err_browser, 'error'); return; }
    toast(T.dl_preparing, 'info');
    window.__generatePDF({ element: el, filename: outName('pdf', '_report'), margin: 10 }).then(function (res) {
        if (res && res.ok === false) { r.abort(); toast(T.err_worker, 'error'); return; }
        r.commit(); toast(T.dl_done, 'success'); complete('pdf');
    }, function () { r.abort(); toast(T.err_worker, 'error'); });
}

/* Premium: the chain applied to every frame of a range, hardware-encoded. */
var clipAbort = null;
function exportClip() {
    if (S.kind !== 'video' || !S.video.loaded) return;
    if (clipAbort) { clipAbort.abort(); return; }
    var from = App().parseTime($('fxClipFrom').value), to = App().parseTime($('fxClipTo').value);
    if (!isFinite(from) || !isFinite(to)) { toast(T.dl_clip_failed, 'warning'); return; }
    from = Math.max(0, from); to = Math.min(S.video.duration, to);
    if (to - from < 0.2) { toast(T.dl_clip_failed, 'warning'); return; }
    if (to - from > 60) { toast(T.dl_clip_too_long, 'warning'); return; }
    if (!window.CanvasVideoExport) { toast(T.dl_clip_unsupported, 'error'); return; }
    var fps = Math.min(30, Math.max(1, Math.round(S.video.fps))), w = S.base.width, h = S.base.height;
    if (w % 2) w--; if (h % 2) h--;
    var enh = JSON.parse(JSON.stringify(S.enh));
    window.CanvasVideoExport.isSupported({ width: w, height: h, fps: fps, format: 'mp4' }).then(function (sup) {
        if (!sup || !sup.ok) { toast(T.dl_clip_unsupported, 'error'); return; }
        var r = beginRun(); if (!r) return;
        clipAbort = new AbortController();
        FX.busy(1, T.dl_clip_busy);
        var n = Math.round((to - from) * fps);
        return window.CanvasVideoExport.encode({
            width: w, height: h, fps: fps, durationSec: n / fps, format: 'mp4', qualityCrf: 18, signal: clipAbort.signal,
            drawFrame: function (c2d, i) {
                return FX.captureAt(from + (i + 0.5) / fps).then(function (img) { return FX.geometryOn(img); }).then(function (b) { return FX.runChain(b, enh); }).then(function (out) {
                    if (out.width !== w || out.height !== h) c2d.drawImage(FX.imageDataToCanvas(out), 0, 0, w, h); else c2d.putImageData(out, 0, 0);
                    FX.busy(0, T.dl_clip_busy + ' ' + Math.round((i + 1) / n * 100) + '%');
                });
            },
            onProgress: function () {}
        }).then(function (blob) {
            r.commit(); toast(T.dl_clip_done, 'success'); complete('clip', { sec: to - from, fps: fps });
            return deliver(blob, outName('mp4', '_enhanced'));
        }, function (e) {
            r.abort();
            if (!(e && e.name === 'AbortError')) { toast(T.dl_clip_failed, 'error'); try { console.error(e); } catch (_) {} }
        }).then(function () { FX.busy(-1); clipAbort = null; App().goToTime(S.sourceMeta.time); });
    });
}

window.FXExport = { run: run, openMenu: openMenu };
})();
